/** @format */

import React from 'react'
import { _$, Card } from '@king-design/react' // , Tabs, Tab
import MonitorCrumb from 'src/components/MonitorCrumb'
import Customboard from './Customboard'
import styled from 'styled-components'
// import Cloudboard from './Cloudboard'

const DashboardList: React.FC<{ className?: string }> = ({ className }) => {
  // const [tabValue, setTabValue] = useState<'customboar' | 'cloudboard'>('customboar')
  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('Dashboard') }]} />
      <Card>
        {/* <Tabs value={tabValue} onChangeValue={(tab) => setTabValue(tab)}>
          <Tab value="customboar">自定义Dashboard</Tab>
          <Tab disabled={true} value="cloudboard">
            云产品Dashboard
          </Tab>
        </Tabs>
        <div className="marginTop">
          <>
            {tabValue === 'customboar' && <Customboard />}
            {tabValue === 'cloudboard' && <Cloudboard />}
          </>
        </div> */}
        <Customboard />
      </Card>
    </div>
  )
}

export default styled(DashboardList)`
  padding: 0 16px;
`
